import React from 'react';

export const StatutEmprunteur: React.FC<unknown> = () => {
    return <></>;
};
